<template>
  <component
    :is="svgUrl ? 'span' : 'b-icon'"
    :icon="svgUrl ? undefined : icon"
    :class="{ 'category-web-icon--svg': svgUrl }"
    :style="svgUrl ? { maskImage: `url(${svgUrl})`, WebkitMaskImage: `url(${svgUrl})` } : undefined"
    aria-hidden="true"
  />
</template>

<script>
const localIcons = {
  cake: require('../assets/category-icons/cake.svg'),
  'car-front': require('../assets/category-icons/car-front.svg'),
  'cup-hot': require('../assets/category-icons/cup-hot.svg'),
  hearts: require('../assets/category-icons/hearts.svg'),
  fire: require('../assets/category-icons/fire.svg'),
  hotdog: require('../assets/category-icons/hotdog.svg'),
  'sushi-roll': require('../assets/category-icons/sushi-roll.svg'),
  'seafood-sushi-rise': require('../assets/category-icons/seafood-sushi-rise.svg'),
  'food-dish-waiter': require('../assets/category-icons/food-dish-waiter.svg'),
  'food-dinner-dish-plate-fork': require('../assets/category-icons/food-dinner-dish-plate-fork.svg'),
  'fries': require('../assets/category-icons/fries.svg'),
  'bowl': require('../assets/category-icons/bowl.svg'),
  'ice-cream-round': require('../assets/category-icons/ice-cream-round.svg'),
  'ice-drink': require('../assets/category-icons/ice-drink.svg'),
  'sugar': require('../assets/category-icons/sugar.svg'),
  'burger': require('../assets/category-icons/burger.svg'),
  'food': require('../assets/category-icons/food.svg'),
  'camping-food-cooking': require('../assets/category-icons/camping-food-cooking.svg'),
  burrito: require('../assets/category-icons/burrito.svg'),
};

export default {
  props: { icon: { type: String, default: '' } },
  computed: {
    svgUrl() {
      return localIcons[this.icon] || '';
    },
  },
};
</script>

<style scoped>
.category-web-icon--svg {
  display: inline-block;
  width: 1em;
  height: 1em;
  flex-shrink: 0;
  background-color: currentColor;
  vertical-align: -0.125em;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
}
</style>
